import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, of } from 'rxjs'
import { Backend } from '../../shared/enums/enums'
import { DdcLoggerService } from '../log/ddc-logger.service'

@Injectable({
  providedIn: 'root',
})
export class AuthUserService {
  constructor(
    private http: HttpClient,
    private logger: DdcLoggerService,
  ) {}

  signUp(credentials: any): any {
    this.logger.info('AuthUserService | signUp | credentials: ' + credentials)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    }

    const userData = {
      first_name: credentials._firstname,
      last_name: credentials._lastname,
      username: credentials._username,
      email: credentials._email,
      password: credentials._password,
    }

    return this.http
      .post(
        `${Backend.HOST_CONTAINER + Backend.REGISTER_AND_SEND_VERIFICATION_CODE}`,
        userData,
        httpOptions,
      )
      .pipe(
        map((res: any) => {
          if (res.success) return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error('AuthUserService | signUp | catchError | errorMessage: ', errorMessage)
          return of(errorMessage)
        }),
      )
  }

  verify(credentials: any, email: string): any {
    this.logger.info('AuthUserService | verify | credentials: ' + credentials)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    }

    const userData = {
      email: email,
      code: credentials._code,
    }

    return this.http
      .post(`${Backend.HOST_CONTAINER + Backend.VERIFY_VERIFICATION_CODE}`, userData, httpOptions)
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error('AuthUserService | verify | catchError | errorMessage: ', errorMessage)
          return of(errorMessage)
        }),
      )
  }

  check_username_email_get_username(credentials: any): any {
    this.logger.info(
      'AuthUserService | check_username_email_get_username | credentials: ' + credentials,
    )
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    }

    const userData = {
      username_or_email: credentials._username_or_email,
    }
    return this.http
      .post(
        `${Backend.HOST_CONTAINER + Backend.CHECK_USERNAME_EMAIL_GET_USERNAME}`,
        userData,
        httpOptions,
      )
      .pipe(
        map((res: any) => {
          if (res.message) return res
        }),
        catchError((error: any) => {
          const errorMessage = error
          this.logger.error(
            'AuthUserService | check_username_email_get_username | catchError | errorMessage: ' +
              errorMessage,
          )
          return of(errorMessage)
        }),
      )
  }

  check_username_email_get_email(credentials: any): any {
    this.logger.info(
      'AuthUserService | check_username_email_get_email | credentials: ' + credentials,
    )
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    }

    const userData = {
      username_or_email: credentials._username_or_email,
    }

    return this.http
      .post(
        `${Backend.HOST_CONTAINER + Backend.CHECK_USERNAME_EMAIL_GET_EMAIL}`,
        userData,
        httpOptions,
      )
      .pipe(
        map((res: any) => {
          if (res.message) return res
        }),
        catchError((error: any) => {
          const errorMessage = error
          this.logger.error(
            'AuthUserService | check_username_email_get_email | catchError | errorMessage: ' +
              errorMessage,
          )
          return of(errorMessage)
        }),
      )
  }

  send_reset_password(email: any): any {
    this.logger.info('AuthUserService | send_reset_password | email: ' + email)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    }

    const userData = {
      email: email,
    }

    return this.http
      .post(`${Backend.HOST_CONTAINER + Backend.SEND_RESET_PASSWORD_EMAIL}`, userData, httpOptions)
      .pipe(
        map((res: any) => {
          if (res.success) return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'AuthUserService | send_reset_password | catchError | errorMessage: ' + errorMessage,
          )
          return of(errorMessage)
        }),
      )
  }

  reset_password(credentials: any, password: string): any {
    this.logger.info('AuthUserService | reset_password | credentials: ' + credentials)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    }

    const userData = {
      user_id: credentials.user_id,
      code: credentials.code,
      token: credentials.token,
      new_password: password,
    }

    return this.http
      .post(`${Backend.HOST_CONTAINER + Backend.RESET_PASSWORD}`, userData, httpOptions)
      .pipe(
        map((res: any) => {
          if (res.success) return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'AuthUserService | reset_password | catchError | errorMessage: ' + errorMessage,
          )
          return of(errorMessage)
        }),
      )
  }

  get_tokens(username: string, password: string): any {
    this.logger.info(
      'AuthUserService | get_tokens | username: ' + username + ' | password: ' + password,
    )
    // ! 3. use username/password as req to /auth/token/
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    const userData = {
      username: username,
      password: password,
    }

    return this.http.post(`${Backend.HOST_CONTAINER + Backend.LOGIN}`, userData, httpOptions).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: any) => {
        const errorMessage = error.error
        this.logger.error(
          'AuthUserService | get_tokens | catchError | errorMessage: ' + errorMessage,
        )
        return of(errorMessage)
      }),
    )
  }

  is_logged_in(): any {
    this.logger.info('AuthUserService | is_logged_in')
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http.get(`${Backend.HOST_CONTAINER + Backend.IS_LOGGED_IN}`, httpOptions).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: any) => {
        const errorMessage = error.error
        this.logger.error(
          'AuthUserService | is_logged_in | catchError | errorMessage: ',
          errorMessage,
        )
        return of(errorMessage)
      }),
    )
  }

  refresh_access_token(): any {
    this.logger.info('AuthUserService | refresh_access_token')
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http.post(`${Backend.HOST_CONTAINER + Backend.REFRESH_TOKEN}`, httpOptions).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: any) => {
        const errorMessage = error.error
        this.logger.error(
          'AuthUserService | refresh_access_token | catchError | errorMessage: ',
          errorMessage,
        )
        return of(errorMessage)
      }),
    )
  }

  sign_out(): any {
    this.logger.info('AuthUserService | sign_out')
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http.get(`${Backend.HOST_CONTAINER + Backend.SIGN_OUT}`, httpOptions).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: any) => {
        const errorMessage = error.error
        this.logger.error('AuthUserService | sign_out | catchError | errorMessage: ', errorMessage)
        return of(errorMessage)
      }),
    )
  }
}
